// Override Settings
var bcSfSearchSettings = {
  search: {
    termKey: 'q'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

/**
 * [buildSuggestionProductPrice description]
 * @param  {[object]} data [description]
 */
BCSfFilter.prototype.buildSuggestionProductPrice = function(data) {
  /* Multi-currency Shopify */
  var self = this;
  self.prepareSuggestionProductPriceData(data);

  // Check on sale
  var onSale = data.compare_at_price_min > data.price_min;
  var packsizeTag = '';
  var hasPackSize = false;
  var packsize = 1;
  var productTags = data.tags;

  for(var i in productTags){
    var tag = productTags[i];
    if(hasPackSize == false && tag.indexOf('pack-size:') != -1){
      hasPackSize = true;
      packsizeTag = tag;
    }
  }
  if(packsizeTag != ''){
    packsize = parseInt(packsizeTag.replace('pack-size:','').trim());
  }

  /* Wholesale Club */
  var discountPercentage = 0;
  if (typeof window.customer_tags !== 'undefined' && window.customer_tags !== '' && window.customer_tags !== null) {
    var discount_tag = window.customer_tags.find(function (tag, index) {
      return tag.substring('customer:trade') !== -1;
    })

    if(discount_tag) {
      discountPercentage = parseInt(discount_tag.split('customer:trade')[1]);
    }
  }
  var tradeDiscount = ((data.price_min * 100 ) * discountPercentage) / 100;

  if(tradeDiscount - Math.floor(tradeDiscount) === 0.5) {
    tradeDiscount = Math.floor(((data.price_min * 100 ) * discountPercentage) / 100);
  }

  var priceHtml = '';
  var fromHtml = '';

  if(data.price_min != data.price_max) {
    fromHtml = 'From: ';
  }

  if(discountPercentage) {
    priceHtml +=
    '<span class="search-flydown--product-price search-flydown--product-price-has-sale">' +
      '<span class="search-flydown--product-price--main">'
        + '<span class="money">' + fromHtml + this.formatMoney((data.price_min * 100 - tradeDiscount)) + '</span>'+
      '</span>' +
      '<span class="search-flydown--product-price--compare-at">' +
        '<span>' + this.formatMoney(data.price_min * 100) + '</span>' +
      '</span>' +
    '</span>';
  } else {
    priceHtml += '<span class="search-flydown--product-price--main">' + fromHtml + this.formatMoney(data.price_min * 100) + '</span>';
  }

  var compareAtPrice = this.formatMoney(data.compare_at_price_min * 100);
  // Build Price
  var result = '';
  if (self.getSettingValue('search.showSuggestionProductPrice')) {
    result += '<div class="' + this.class.searchSuggestion + '-product-price">';
    if (onSale && self.getSettingValue('search.showSuggestionProductSalePrice')) {
      result += '<s>' + compareAtPrice + '</s>  ';
      result += '<div class="bc-sf-product-sale-price">' + priceHtml + '</div>';
    } else {
      result += '<div class="bc-sf-product-regular-price">' + priceHtml + '</div>';
    }
    result += '</div>';
  }
  return result;
};
